import { render, staticRenderFns } from "./CommunityGroupBanner.vue?vue&type=template&id=0c1978ea&scoped=true&"
import script from "./CommunityGroupBanner.vue?vue&type=script&lang=js&"
export * from "./CommunityGroupBanner.vue?vue&type=script&lang=js&"
import style0 from "./CommunityGroupBanner.vue?vue&type=style&index=0&id=0c1978ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1978ea",
  null
  
)

export default component.exports